import React, { useEffect, useState, useRef } from "react";
import {
  Chat,
  Channel,
  ChannelHeader,
  MessageList,
  Window,
  Thread,
  LoadingIndicator,
} from "stream-chat-react";
import { StreamChat } from "stream-chat";
import "stream-chat-react/dist/css/v2/index.css";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { FaPaperPlane } from "react-icons/fa";
import { GoPlusCircle } from "react-icons/go";
import { FaFile } from "react-icons/fa";

const apiKey = "689zge653a2x";

const userId = "clinician-test-2";
const user = {
  id: String(userId),
  name: "clinician-test-2",
};
const otherUser = "212";

const Stream = () => {
  const [chatClient, setChatClient] = useState(null);
  const [channel, setChannel] = useState(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [messageInputValue, setMessageInputValue] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const messageInputRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const initChat = async () => {
      const client = StreamChat.getInstance(apiKey);
      const devToken = client.devToken(user.id);

      try {
        await client.connectUser(user, devToken);
        const userList = await client.queryUsers({
          id: { $in: [user.id, otherUser] },
        });

        if (userList.users.length < 2) {
          console.warn(`Other user (${otherUser}) not found.`);
          return;
        }

        const uniqueChannelId = [user.id, otherUser].sort().join("-");
        const channel = client.channel("messaging", uniqueChannelId, {
          name: `Chat with ${otherUser}`,
          members: [user.id, otherUser],
        });

        await channel.watch();
        setChatClient(client);
        setChannel(channel);
      } catch (err) {
        console.error("Stream setup failed:", err);
      }
    };

    initChat();
    return () => {
      if (chatClient) chatClient.disconnectUser();
    };
  }, []);

  const addEmoji = (emoji) => {
    const textarea = messageInputRef.current;
    if (textarea) {
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const newValue =
        messageInputValue.slice(0, start) +
        emoji.native +
        messageInputValue.slice(end);
      setMessageInputValue(newValue);
      setTimeout(() => {
        textarea.setSelectionRange(
          start + emoji.native.length,
          start + emoji.native.length
        );
        textarea.focus();
      }, 0);
    }
  };

  const handleSendMessage = async () => {
    if (!messageInputValue.trim() && !selectedFile) return;

    const message = { text: messageInputValue };

    if (selectedFile) {
      try {
        let fileUpload;
        const isImage = selectedFile.type.startsWith("image/");

        if (isImage) {
          fileUpload = await channel.sendImage(selectedFile);
          message.attachments = [
            {
              type: "image",
              image_url: fileUpload.file,
              fallback: selectedFile.name,
            },
          ];
        } else {
          fileUpload = await channel.sendFile(selectedFile);
          message.attachments = [
            {
              type: "file",
              asset_url: fileUpload.file,
              title: selectedFile.name,
              file_size: selectedFile.size,
              mime_type: selectedFile.type,
            },
          ];
        }
      } catch (error) {
        console.error("File upload failed:", error);
      }

      setSelectedFile(null);
    }

    await channel.sendMessage(message);
    setMessageInputValue("");
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setMessageInputValue("");
      setTimeout(() => handleSendMessage(), 0); // Ensure file is set before sending
    }
  };

  if (!chatClient || !channel) return <LoadingIndicator />;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "50%" }}>
        <h2 style={{ textAlign: "center", margin: "20px 0" }}>
          Dev Playground
        </h2>
        <p style={{ textAlign: "center", margin: "10px 0" }}>
          Logged in as <b>{user.name}</b>
        </p>
        <Chat client={chatClient} theme="str-chat__theme-light">
          <Channel channel={channel}>
            <Window>
              {/* <ChannelHeader /> */}
              <MessageList />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px",
                  position: "relative",
                }}
              >
                {/* File upload button */}
                <button
                  onClick={() => fileInputRef.current.click()}
                  style={{
                    padding: "12px 0 8px 5px",
                    fontSize: "24px",
                    cursor: "pointer",
                    border: "none",
                    background: "transparent",
                    color: "#ccc",
                  }}
                  title="Attach file"
                >
                  <GoPlusCircle />
                </button>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />

                {/* Emoji toggle button */}
                <button
                  onClick={() => setShowEmojiPicker((prev) => !prev)}
                  style={{
                    padding: "8px 0 8px 0",
                    fontSize: "24px",
                    cursor: "pointer",
                    border: "none",
                    background: "transparent",
                    color: "#fc6448",
                  }}
                  title="Insert emoji"
                >
                  😀
                </button>

                {/* Message input */}
                <textarea
                  ref={messageInputRef}
                  value={messageInputValue}
                  onChange={(e) => setMessageInputValue(e.target.value)}
                  onFocus={() => setShowEmojiPicker(false)}
                  rows={1}
                  style={{
                    flex: 1,
                    resize: "none",
                    padding: "10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "24px",
                    fontFamily: "inherit",
                  }}
                />

                {/* Send button */}
                <button
                  onClick={handleSendMessage}
                  style={{
                    padding: "8px",
                    fontSize: "24px",
                    cursor: "pointer",
                    border: "none",
                    background: "transparent",
                    color: "#fc6448",
                  }}
                  title="Send message"
                >
                  <FaPaperPlane />
                </button>

                {/* Emoji Picker */}
                {showEmojiPicker && (
                  <div
                    style={{
                      position: "absolute",
                      zIndex: 10,
                      bottom: "60px",
                      left: "40px",
                    }}
                  >
                    <Picker data={data} onEmojiSelect={addEmoji} />
                  </div>
                )}
              </div>

              {/* Image preview before auto-send (brief flash) */}
              {selectedFile && (
                <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
                  {selectedFile.type.startsWith("image/") ? (
                    <img
                      src={URL.createObjectURL(selectedFile)}
                      alt="preview"
                      style={{
                        maxWidth: "100px",
                        maxHeight: "100px",
                        borderRadius: "4px",
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <FaFile style={{ fontSize: "48px", color: "#ccc" }} />
                  )}
                </div>
              )}
            </Window>
            <Thread />
          </Channel>
        </Chat>
      </div>
    </div>
  );
};

export default Stream;
